<template>
  <CrudList
    title="Provincias"
    storeName="Provinces"
    labelAddNew="Agregar"
    slot-scope="{ item }"
    sortable
    canSearch
    next-link="/admin/tags"
    :breadcrumbs="[
      {
        text: 'Spots y vehículos',
        disabled: false,
        href: '/admin/provinces'
      },
      {
        text: 'Provincias',
        disabled: false,
        href: '#'
      }
    ]"
  >
    <template v-slot:cities="{ item }">
      <v-btn
          elevation="0"
          class="my-1 btn-black btn-round-md"
          rounded
          color="primary"
          @click="$router.push('/admin/provinces/' + item.id + '/cities')"
      >
        Ciudades 
      </v-btn>
    </template>

  </CrudList>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";

export default {
  components: { CrudList },
};
</script>
